import { render, staticRenderFns } from "./makeMessagesAsRead.vue?vue&type=template&id=2888395c"
import script from "./makeMessagesAsRead.vue?vue&type=script&lang=js"
export * from "./makeMessagesAsRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports